import { Tooltip } from '@mui/material';
import { Folder as FolderIcon } from '@mui/icons-material';
import { StyledChip } from './SharedStyles';

const truncateFolderPathFromLeft = (path: string, maxLength = 25): string => {
  if (path.length <= maxLength) return path;
  return '...' + path.slice(-(maxLength - 3));
};

export const FolderPathsDetail = ({ folderPaths }: { folderPaths?: string[] }) => {
  if (!folderPaths) return;

  const displayLabel =
    folderPaths.length === 1 ? truncateFolderPathFromLeft(folderPaths[0]) : `${folderPaths.length} folders`;

  const tooltipTitle = folderPaths.length === 1 ? folderPaths[0] : folderPaths.join(', ');

  return (
    <Tooltip title={tooltipTitle}>
      <StyledChip icon={<FolderIcon />} label={displayLabel} size='small' color='primary' />
    </Tooltip>
  );
};
